import { Box, Typography } from "@mui/material";

const EditorLabel = (props: { label: string }) => {
  const { label } = props;
  return (
    <Box
      position="absolute"
      bottom={0}
      right={0}
      bgcolor="text.secondary"
      color="background.paper"
      pl={1}
      pr={1}
    >
      <Typography variant="caption">{label}</Typography>
    </Box>
  );
};
export default EditorLabel;
